import React from "react";
import * as moment from 'moment-timezone';
import { IoMdClose } from "react-icons/io";

const ViewDisputeReceipt = ({ disputeData, onClose, guestName }) => {
    console.log("receipt data", disputeData)
    const actualGuestName = guestName ?? "Crewmates"
    return (
      <>
        <div className="tw-bg-white p-4 tw-rounded-md tw-relative">
          <span
            onClick={onClose}
            className="tw-right-6 tw-top-6 tw-cursor-pointer align-right"
          >
            <IoMdClose size={32} />
          </span>

          <h2 className="text-3xl font-medium">Dispute Closed</h2>
          <h3 className="text-2xl font-medium my-4">Your Dispute Settlement from {actualGuestName}</h3>
          <p className="tw-text-gray-500 tw-mt-2">
          Receipt ID: {disputeData.receiptId?disputeData.receiptId:disputeData.bookingId}{" "}
          {disputeData.updatedAt &&
            `- ${moment(disputeData.updatedAt).tz(disputeData.timezone).format("MMMM DD, YYYY")}`}
        </p>
        <p className="tw-text-gray-500 tw-mt-2">
          Booking ID: {disputeData.originalBookingId}{" "}
        </p>
        <br />
        <h3 className="text-2xl font-medium tw-mb-3">Dispute Details</h3>
          <p className="tw-mb-1">Dispute ID: {disputeData._id}</p>
          <p className="tw-mb-1">Amount Awarded: ${parseFloat(disputeData.amount)
                  .toFixed(2)
                  .toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}</p>

          <hr className="tw-col-span-full" />
          <div className="tw-grid tw-grid-cols-2 mt-3 d-flex align-items-center justify-content-between">
            <div className="flex-col flex">
              <h4 className="text-xl font-medium mb-3">Payment by {actualGuestName}</h4>
              <p className="tw-text-gray-500">
                {moment(disputeData.createdAt).tz(disputeData.timezone).format(
                  "MMMM DD, YYYY h:mm:ss zz"
                )}{" "}
              </p>
            </div>
            <p className="tw-text-right tw-text-gray-500">
              {`$${parseFloat(disputeData.amount)
                  .toFixed(2)
                  .toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}`}
            </p>
          </div>

          <hr className="tw-col-span-full" />

          <div className="tw-grid tw-grid-cols-2 mt-3 d-flex align-items-center justify-content-between">
            
          <p className="tw-font-medium tw-text-black">Net Earnings</p>
          
            <p className="tw-font-medium tw-text-black tw-text-right">
            {`$${disputeData.amount &&
                                parseFloat(disputeData.amount).toFixed(2).toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                })}`}
            </p>
          </div>
        </div>
      </>
    );
  };

  export default ViewDisputeReceipt